import React from "react";

// Marketing landing for users who arrive at the website without the
// mobile app installed. Links to both stores; OS sniffing is
// intentionally avoided so both options stay visible (some users browse
// on desktop and want to send the link to their phone).
export function GetAppPage() {
  return (
    <div
      style={{
        padding: 24,
        maxWidth: 560,
        margin: "0 auto",
        fontFamily: "sans-serif",
        textAlign: "center",
      }}
    >
      <h2>Get Dog Controller on your phone</h2>
      <p style={{ color: "#444", lineHeight: 1.5 }}>
        The mobile app turns your phone into a dog-mounted tracker, recording
        position and capturing photos/video from your dog's perspective. It
        also pairs with Garmin watches for Connect IQ collar data.
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 24,
          marginTop: 32,
          flexWrap: "wrap",
        }}
      >
        <a
          href="https://apps.apple.com/app/dog-controller"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "14px 28px",
            fontSize: 16,
            backgroundColor: "#000",
            color: "white",
            borderRadius: 10,
            textDecoration: "none",
            minWidth: 180,
          }}
        >
          Download on the App Store
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.dogcontroller"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "14px 28px",
            fontSize: 16,
            backgroundColor: "#0f9d58",
            color: "white",
            borderRadius: 10,
            textDecoration: "none",
            minWidth: 180,
          }}
        >
          Get it on Google Play
        </a>
      </div>

      <p style={{ marginTop: 40, fontSize: 13, color: "#888" }}>
        Looking for the in-browser version? Use the{" "}
        <a href="/webapp" style={{ color: "#ff8c00" }}>
          web app
        </a>{" "}
        instead.
      </p>
    </div>
  );
}
